// extracted by mini-css-extract-plugin
export default {"arrowUIWrapperContainer":"ArrowUIWrapper_arrowUIWrapperContainer__Ertgw","adsContainer":"ArrowUIWrapper_adsContainer__2LtE9"};